// Progressive Web App (PWA) Install & Update Manager
if (!window.__fiestasweeps_pwa_initialized) {
    window.__fiestasweeps_pwa_initialized = true;

    let deferredPrompt = null;
    let promptFired = false;
    let swRegistration = null;

    const isStandalone = () => {
        return window.navigator.standalone === true || window.matchMedia('(display-mode: standalone)').matches;
    };

    const isMobileDevice = () => {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
            ('ontouchstart' in window) ||
            window.innerWidth <= 1024;
    };

    const isIOSDevice = () => {
        return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    };

    const showBanner = (type, registration = null) => {
        // Don't show install banner if already installed or dismissed in this session
        if (type !== 'update' && (isStandalone() || sessionStorage.getItem('pwa_banner_dismissed') === 'true')) {
            return;
        }

        // Remove any existing banner
        const existing = document.getElementById('pwa-header-banner');
        if (existing) existing.remove();

        const banner = document.createElement('div');
        banner.id = 'pwa-header-banner';

        let title = 'Fiesta Sweeps App';
        let desc = 'Install for instant access & smoother gameplay';
        let btnText = 'Install App';
        let btnIcon = 'fa-download';

        if (type === 'update') {
            title = 'Update Available';
            desc = 'A new version of Fiesta Sweeps is ready!';
            btnText = 'Update Now';
            btnIcon = 'fa-sync-alt';
        } else if (type === 'ios-install') {
            title = 'Install Fiesta Sweeps';
            desc = 'Tap Share <i class="fas fa-share-square" style="color: #60a5fa;"></i> then "Add to Home Screen" <i class="fas fa-plus-square" style="color: #60a5fa;"></i>';
            btnText = 'Got It';
            btnIcon = 'fa-check';
        }

        banner.style.cssText = `
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            z-index: 9999999;
            background: linear-gradient(135deg, rgba(22, 22, 29, 0.96) 0%, rgba(15, 15, 20, 0.98) 100%);
            backdrop-filter: blur(16px);
            -webkit-backdrop-filter: blur(16px);
            border-bottom: 1px solid rgba(167, 139, 250, 0.25);
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.6), 0 0 25px rgba(167, 139, 250, 0.15);
            color: #FFFFFF;
            padding: 10px 16px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 12px;
            font-family: 'DM Sans', 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
            transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.4s ease;
            transform: translateY(-100%);
            opacity: 0;
            box-sizing: border-box;
        `;

        banner.innerHTML = `
            <div style="display: flex; align-items: center; gap: 12px; min-width: 0; flex: 1;">
                <div style="width: 42px; height: 42px; border-radius: 12px; background: linear-gradient(135deg, #a78bfa, #7c3aed); display: flex; align-items: center; justify-content: center; flex-shrink: 0; box-shadow: 0 4px 14px rgba(124, 58, 237, 0.45); border: 1px solid rgba(255, 255, 255, 0.2);">
                    <img src="/apple-icon-60x60.png" alt="Icon" style="width: 28px; height: 28px; border-radius: 6px; object-fit: cover;" onerror="this.style.display='none'; this.nextElementSibling.style.display='inline-block';" />
                    <i class="fas fa-mobile-alt" style="font-size: 20px; color: #ffffff; display: none;"></i>
                </div>
                <div style="min-width: 0;">
                    <div style="margin: 0; font-size: 14px; font-weight: 700; color: #ffffff; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; letter-spacing: 0.3px;">
                        ${title}
                    </div>
                    <div style="margin: 2px 0 0 0; font-size: 12px; color: #d8b4fe; line-height: 1.3; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                        ${desc}
                    </div>
                </div>
            </div>
            <div style="display: flex; align-items: center; gap: 8px; flex-shrink: 0;">
                <button id="pwa-action-btn" style="background: linear-gradient(135deg, #a78bfa, #7c3aed); color: #ffffff; border: 1px solid rgba(255, 255, 255, 0.25); padding: 8px 16px; border-radius: 20px; font-size: 12px; font-weight: 700; cursor: pointer; box-shadow: 0 4px 14px rgba(124, 58, 237, 0.4); transition: all 0.2s ease; display: flex; align-items: center; gap: 6px; font-family: inherit;">
                    <i class="fas ${btnIcon}"></i> <span>${btnText}</span>
                </button>
                <button id="pwa-close-btn" style="background: rgba(255, 255, 255, 0.1); border: 1px solid rgba(255, 255, 255, 0.15); color: #9ca3af; width: 32px; height: 32px; border-radius: 50%; display: flex; align-items: center; justify-content: center; cursor: pointer; transition: all 0.2s ease; font-size: 14px; padding: 0;">
                    <i class="fas fa-times"></i>
                </button>
            </div>
        `;

        document.body.appendChild(banner);

        const closeBanner = () => {
            banner.style.transform = 'translateY(-100%)';
            banner.style.opacity = '0';
            setTimeout(() => banner.remove(), 400);
            document.body.style.paddingTop = '';
            document.querySelectorAll('.mobile-nav, .desktop-nav').forEach(nav => {
                nav.style.top = '';
            });
            sessionStorage.setItem('pwa_banner_dismissed', 'true');
        };

        const actionBtn = banner.querySelector('#pwa-action-btn');
        const closeBtn = banner.querySelector('#pwa-close-btn');

        closeBtn.addEventListener('click', closeBanner);

        actionBtn.addEventListener('click', () => {
            if (type === 'update') {
                if (registration && registration.waiting) {
                    registration.waiting.postMessage({ type: 'SKIP_WAITING' });
                } else {
                    window.location.reload();
                }
            } else if (type === 'install') {
                if (deferredPrompt) {
                    deferredPrompt.prompt();
                    deferredPrompt.userChoice.then((choiceResult) => {
                        if (choiceResult.outcome === 'accepted') {
                            console.log('User accepted the install prompt');
                            closeBanner();
                        }
                        deferredPrompt = null;
                    });
                } else {
                    alert('To install: open your browser menu (⋮ or ⬆️) and select "Add to Home Screen" or "Install App".');
                    closeBanner();
                }
            } else if (type === 'ios-install') {
                closeBanner();
            }
        });

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                banner.style.transform = 'translateY(0)';
                banner.style.opacity = '1';

                document.body.style.transition = 'padding-top 0.3s ease';
                document.body.style.paddingTop = '64px';

                document.querySelectorAll('.mobile-nav, .desktop-nav').forEach(nav => {
                    nav.style.transition = 'top 0.3s ease';
                    nav.style.top = '4.5rem';
                });
            });
        });
    };

    // Expose PWA state and trigger methods globally for Player SPA & Vue components
    window.__PWA_STATE__ = {
        isStandalone: isStandalone(),
        isIOS: isIOSDevice(),
        isMobile: isMobileDevice(),
        canInstall: false,
        updateAvailable: false
    };

    window.triggerPwaInstall = () => {
        if (deferredPrompt) {
            deferredPrompt.prompt();
            deferredPrompt.userChoice.then((choiceResult) => {
                if (choiceResult.outcome === 'accepted') {
                    window.__PWA_STATE__.canInstall = false;
                    window.__PWA_STATE__.isStandalone = true;
                    window.dispatchEvent(new CustomEvent('pwa-installed'));
                }
                deferredPrompt = null;
            });
        } else if (isIOSDevice()) {
            showBanner('ios-install');
        } else {
            alert('To install FiestaSweeps: open your browser menu (⋮ or ⬆️) and select "Add to Home Screen" or "Install App".');
        }
    };

    window.triggerPwaUpdate = () => {
        if (swRegistration && swRegistration.waiting) {
            swRegistration.waiting.postMessage({ type: 'SKIP_WAITING' });
        } else {
            window.location.reload();
        }
    };

    window.addEventListener('appinstalled', () => {
        window.__PWA_STATE__.isStandalone = true;
        window.__PWA_STATE__.canInstall = false;
        window.dispatchEvent(new CustomEvent('pwa-installed'));
    });

    // Register Service Worker
    if ('serviceWorker' in navigator) {
        window.addEventListener('load', () => {
            navigator.serviceWorker.register('/swapp.js').then((registration) => {
                swRegistration = registration;

                if (registration.waiting) {
                    window.__PWA_STATE__.updateAvailable = true;
                    window.dispatchEvent(new CustomEvent('pwa-update-available'));
                    showBanner('update', registration);
                    return;
                }

                registration.addEventListener('updatefound', () => {
                    const newWorker = registration.installing;
                    if (newWorker) {
                        newWorker.addEventListener('statechange', () => {
                            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                                window.__PWA_STATE__.updateAvailable = true;
                                window.dispatchEvent(new CustomEvent('pwa-update-available'));
                                showBanner('update', registration);
                            }
                        });
                    }
                });
            }).catch((err) => {
                console.error('ServiceWorker registration failed: ', err);
            });
        });

        let refreshing = false;
        navigator.serviceWorker.addEventListener('controllerchange', () => {
            if (!refreshing) {
                refreshing = true;
                window.location.reload();
            }
        });
    }

    // Listen for Chrome/Android native install prompt
    window.addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault();
        deferredPrompt = e;
        promptFired = true;
        window.__PWA_STATE__.canInstall = true;
        window.dispatchEvent(new CustomEvent('pwa-installable'));
        showBanner('install');
    });

    // Fallback check after 2 seconds for mobile devices
    setTimeout(() => {
        if (!isStandalone() && !promptFired && sessionStorage.getItem('pwa_banner_dismissed') !== 'true') {
            if (isIOSDevice() && isMobileDevice()) {
                window.__PWA_STATE__.canInstall = true;
                window.dispatchEvent(new CustomEvent('pwa-installable'));
                showBanner('ios-install');
            } else if (isMobileDevice()) {
                window.__PWA_STATE__.canInstall = true;
                window.dispatchEvent(new CustomEvent('pwa-installable'));
                showBanner('install');
            }
        }
    }, 2000);
}
